import { render, staticRenderFns } from "./ExcelDownloadSecuritySetting.vue?vue&type=template&id=dba3c370&"
import script from "./ExcelDownloadSecuritySetting.vue?vue&type=script&lang=ts&"
export * from "./ExcelDownloadSecuritySetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports